var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M3.855 11.339c0 1.034-.836 1.87-1.87 1.87a1.87 1.87 0 11-.001-3.741h1.871v1.87zm.936 0c0-1.035.836-1.871 1.87-1.871 1.035 0 1.871.836 1.871 1.87v4.678c0 1.034-.836 1.87-1.87 1.87a1.869 1.869 0 01-1.871-1.87v-4.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M6.661 3.827a1.869 1.869 0 01-1.87-1.871A1.867 1.867 0 016.66.085c1.035 0 1.871.836 1.871 1.87v1.872h-1.87zm0 .95c1.035 0 1.871.836 1.871 1.87a1.869 1.869 0 01-1.87 1.871H1.97A1.868 1.868 0 01.1 6.648c0-1.035.835-1.872 1.87-1.872h4.691z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M14.16 6.647c0-1.034.835-1.87 1.87-1.87 1.035 0 1.87.836 1.87 1.87a1.868 1.868 0 01-1.87 1.871h-1.87v-1.87zm-.936 0a1.87 1.87 0 01-1.871 1.871 1.869 1.869 0 01-1.871-1.87V1.955c0-1.035.836-1.871 1.87-1.871a1.87 1.87 0 011.872 1.87v4.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M11.353 14.145c1.034 0 1.87.836 1.87 1.87a1.87 1.87 0 11-3.741.001v-1.871h1.87zm0-.936a1.869 1.869 0 01-1.871-1.87c0-1.035.836-1.871 1.87-1.871h4.692c1.035 0 1.871.836 1.871 1.87a1.869 1.869 0 01-1.87 1.871h-4.692z"
  }))));
}
export default SvgSlackIcon;